import React from 'react'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default function Messenger(props) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C5.24004 0 0 4.95169 0 11.64C0 15.1385 1.43376 18.1615 3.76867 20.2496C3.96468 20.425 4.083 20.6708 4.09104 20.9338L4.15639 23.0684C4.17727 23.7492 4.88057 24.1923 5.50361 23.9172L7.88544 22.8658C8.08735 22.7768 8.3136 22.7602 8.52636 22.8188C9.62088 23.1197 10.7858 23.28 12 23.28C18.76 23.28 24 18.3284 24 11.64C24 4.95169 18.76 0 12 0ZM4.79308 15.0424L8.31808 9.44995C8.87879 8.56027 10.0795 8.33875 10.9208 8.96971L13.7244 11.0724C13.9817 11.2654 14.3356 11.2644 14.5918 11.07L18.3782 8.19631C18.8836 7.81279 19.5432 8.41759 19.205 8.95431L15.68 14.5468C15.1193 15.4365 13.9186 15.658 13.0773 15.027L10.2736 12.9243C10.0164 12.7314 9.66244 12.7324 9.40631 12.9268L5.61988 15.8004C5.11451 16.1839 4.4548 15.5791 4.79308 15.0424Z"
      />
    </BaseIcon>
  )
}
